import { DocumentationLegacyItemType } from "../enums/SDKDocumentationLegacyItemType";
import { DocumentationLegacyItem, } from "./SDKDocumentationLegacyItem";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyGroup extends DocumentationLegacyItem {
    /** Children filtered to be only groups */
    get subgroups() {
        return this.children.filter((c) => c.type === DocumentationLegacyItemType.group);
    }
    /** Children filtered to be only pages */
    get pages() {
        return this.children.filter((c) => c.type === DocumentationLegacyItemType.page);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        super(model);
        this.type = DocumentationLegacyItemType.group;
        this.isRoot = model.isRoot;
        this.childrenIds = model.childrenIds;
        this.children = new Array();
        this.groupBehavior = model.groupBehavior;
        this.relativeFirstPageUrl = null;
        this.deployedFirstPageUrl = null;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Convenience
    addChild(item) {
        this.children.push(item);
    }
    addChildren(groups) {
        this.children = this.children.concat(groups);
    }
    setParent(parent) {
        this.parent = parent !== null && parent !== void 0 ? parent : null;
    }
    /** Internal: Modifies object with new paths. Don't use outside SDK environment as it doesn't propagate the data back to source */
    internalOverridePaths(relative, deployed) {
        this.relativeFirstPageUrl = relative;
        this.deployedFirstPageUrl = deployed;
    }
    /** Retrieve relative page path without the associated domain for the first page in the group. Will work even when documentation was not yet deployed */
    relativeDocsPageUrl() {
        return this.relativeFirstPageUrl;
    }
    /** Retrieve page url for the first page in the group, if the documentation was already deployed (either default or custom domain) */
    deployedDocsPageUrl() {
        return this.deployedFirstPageUrl;
    }
}
